import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './components/header';
import { FooterComponent } from './components/footer';
import { AboutUsComponent } from './components/about-us';
import { RouterModule } from '@angular/router';
import { AbbreviationComponent } from './components/abbreviation';
import { HelpComponent } from './components/help';
import { ContactComponent } from './components/contact';
import { SiteMapComponent } from './components/site-map';
import { LinksComponent } from './components/links';
import { AdvancedSearchContainerComponent } from './containers/advanced-search';
import { MapSearchContainerComponent } from './containers/map-search';
import { GoogleMapContainer } from './containers/google-map';
import { AdvancedSearchFormComponent } from './components/advanced-search-form';
import { DialogModule } from 'primeng/components/dialog/dialog';
import { MaphilightModule } from 'ng-maphilight';
import { AdminSectionContainerComponent } from './containers/admin-section';
import { AdminHomeComponent } from './components/admin';
import { LeftNavigationComponent } from './components/left-navigation';
import { AdminSiteListContainerComponent } from './containers/admin-site-list';
import { AdminDocumentsContainerComponent } from './containers/admin-documents';
import { AllFarmsMapComponent } from './components/all-farms-map';
import { SouthFarmMapComponent } from './components/south-farm-map';
import { NorthFarmMapComponent } from './components/north-farm-map';
import { LinkageFarmMapComponent } from './components/linkage-farm-map';
import { CentralFarmMapComponent } from './components/central-farm-map';
import { EastFarmMapComponent } from './components/east-farm-map';
import { AdminManageSiteContainerComponent } from './containers/admin-manage-site';
import { StoreModule } from '@ngrx/store';
import {reducers} from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { SiteEffects } from './effects/site';
import { SiteService } from './services/site';
import { SiteListComponent } from './components/site-list';
import { SiteFormComponent } from './components/site-form';
import { SiteDetailComponent } from './components/site-detail';
import { SearchResultsContainerComponent } from './containers/search-results';
import { SearchCriteriaComponent } from './components/search-criteria';
import { SearchResultsListComponent } from './components/search-results-list';
import { SearchEffects } from './effects/search';
import {DataTableModule} from 'primeng/components/datatable/datatable';
import { DocumentService } from '../irar/services/document';
import { DocumentEditFormComponent } from './components/document-edit-form';
import { AutoCompleteModule } from 'primeng/components/autocomplete/autocomplete';
import { FileUploadComponent } from './components/file-upload';
import { CalendarModule } from 'primeng/components/calendar/calendar';
import { GoogleMapComponent } from './components/google-map';
import { BarcLandingPageComponent } from './containers/barc-landing';
import { GlenDaleComponent } from './containers/glen-dale';
import { GlennDaleResultsComponent } from './components/glenn-dale-results';

@NgModule({
  imports: [CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    DialogModule,
    MaphilightModule,
    DataTableModule,
    CalendarModule,
    AutoCompleteModule,
    EffectsModule.forFeature([SiteEffects, SearchEffects]),
    StoreModule.forFeature('irar', reducers)
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    AboutUsComponent,
    AbbreviationComponent,
    HelpComponent,
    ContactComponent,
    SiteMapComponent,
    LinksComponent,
    AdvancedSearchContainerComponent,
    MapSearchContainerComponent,
    GoogleMapContainer,
    GoogleMapComponent,
    AdvancedSearchFormComponent,
    AdminSectionContainerComponent,
    AdminHomeComponent,
    LeftNavigationComponent,
    AdminSiteListContainerComponent,
    AdminDocumentsContainerComponent,
    AllFarmsMapComponent,
    SouthFarmMapComponent,
    NorthFarmMapComponent,
    LinkageFarmMapComponent,
    CentralFarmMapComponent,
    EastFarmMapComponent,
    AdminManageSiteContainerComponent,
    SiteListComponent,
    SiteFormComponent,
    SiteDetailComponent,
    SearchResultsContainerComponent,
    SearchCriteriaComponent,
    SearchResultsListComponent,
    DocumentEditFormComponent,
    FileUploadComponent,
    BarcLandingPageComponent,
    GlenDaleComponent,
    GlennDaleResultsComponent
  ],
  exports: [
    HeaderComponent,
    FooterComponent
  ],
  providers: [
    SiteService,
    DocumentService
  ]
})
export class IrarModule { }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/irar.module.ts